import {custom, deserialize, list, serialize, SKIP} from "serializr";
import {MapAddonType} from "@/modules/redactor/models/map-addon/core/MapAddonType";
import {MapAddonModel} from "@/modules/redactor/models/map-addon/core/MapAddonModel";
import {MapAddonIslandModel} from "@/modules/redactor/models/map-addon/island/MapAddonIslandModel";

export class MapAddonUtils {

    static create(type) {
        if (MapAddonType.ISLAND.equal(type)) {
            return new MapAddonIslandModel();
        }
        console.error("unknown map-addon type");
        return null;
    }

    static serialize(value) {
        if (!(value instanceof MapAddonModel)) {
            console.error("invalid type");
        } else if (MapAddonType.ISLAND.equal(value.type)) {
            return serialize(MapAddonIslandModel, value);
        } else {
            console.error("unknown map-addon type");
        }
        return SKIP;
    }

    static deserialize(value) {
        if (MapAddonType.ISLAND.equal(value.type)) {
            return deserialize(MapAddonIslandModel, value);
        } else {
            console.error("unknown map-addon type");
        }
        return SKIP;
    }

    static schema() {
        return list(custom(
            (value) => MapAddonUtils.serialize(value),
            (value) => MapAddonUtils.deserialize(value)
        ))
    }

}